<template>
  <v-col cols="12" md="6" lg="4" xl="2">
  <v-card class="mx-auto">
    <v-toolbar color=#EEE light height=60>
      <v-toolbar-title class="race-title">{{system.code}}-{{race.leg_nr}}
      </v-toolbar-title>
      <div class="race-time-box" v-if="raceNotStarted">{{race.start_time | moment('HH:mm')}} ({{ race.start_time | fromNow }})</div>
      <div class="race-time-box" v-if="raceStarted">{{race.start_time | moment('HH:mm')}} Loppet pågår!</div>
      <div class="race-time-box" v-if="raceOver">{{race.start_time | moment('HH:mm')}} Loppet är slut!</div>

      <v-spacer></v-spacer>

      <span style="margin-right:4px;color:#555">{{race.distance}}m</span>

      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon v-if="race.start_method === 'V'" v-on="on">mdi-alpha-v-circle-outline</v-icon>
          <v-icon v-if="race.start_method === 'A'" v-on="on">mdi-car</v-icon>
        </template>
        <span v-if="race.start_method === 'V'">Voltstart</span>
        <span v-if="race.start_method === 'A'">Autostart</span>
      </v-tooltip>

    </v-toolbar>

    <v-expansion-panels v-model="topPanels">
      <v-expansion-panel v-if="results.Winners" >
        <v-expansion-panel-header style="font-size:18px" @click="showResults = !showResults">
          <v-icon style="color:orange">mdi-star</v-icon>
          <span>Resultat</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="race-results-box">
            <strong>Vinnare:</strong>
          <v-avatar
            v-for="(winner, index) in results.Winners"
            :key="`winner-${race.leg_nr}-${index}`"
            size="24px"
            class="green"
            style="color:white;font-size:14px;font-weight:bold;margin-left:3px"
          >{{winner}}
          </v-avatar>
          <br/>
          <strong>System kvar:</strong> <span>{{results.SystemsLeft | numberSpacing}} st.</span><br/>
          <strong>Värde:</strong> <span>{{results.Value | numberSpacing }}:-</span><br/>
          <strong>Rader kvar med chans:</strong> <span v-text="results.NOR.toString().replace(/,/g, ' / ')"></span>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header style="font-size:12px">{{race.race_info_short}}</v-expansion-panel-header>
        <v-expansion-panel-content style="font-size:12px">
          {{race.race_info_long}}
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-list>

      <v-list-item
        v-for="item in sortedItems"
        :key="item.id"
        :data-ownrank="item.system_horse.own_rank"
        :id="item.id"
        style="padding:0px 0px 2px 2px"
        class="d-flex horse-row"
        :class="[item.system_horse.selected ? 'selected-item' : 'not-selected-item', item.cancelled ? 'cancelled' : '', (results && results.Winners && results.Winners.includes(item.start_nr) && displayResults) ? 'winner' : '']"
        :draggable="sorting === 'own_rank'"
        @dragstart="dragStart(item, $event)"
        @dragend="dragEnd" >

        <v-list-item-action style="margin-right:5px" class="horse-row-content">
          <v-btn icon @click="toggleHorse(item)" :disabled="isLocked || (item.cancelled && !item.system_horse.selected)">
            <v-avatar :class="item.system_horse.selected ? 'selected-avatar' : 'not-selected-avatar'" size="30">
              <span class="white--text title">{{item.start_nr}}</span>
            </v-avatar>
          </v-btn>
        </v-list-item-action>

        <v-list-item-content style="flex-grow:3" class="horse-row-content">
          <v-list-item-title v-text="item.name"></v-list-item-title>
          <v-list-item-subtitle v-text="item.driver_long"></v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-content class="horse-row-content">
          <span class="font-weight-black text-right">
            {{item.stake_distribution_share}}%</span><br />
          <span class="text-right">{{item.odds}}</span>
        </v-list-item-content>

        <v-avatar
          outlined
          size="16px"
          class="blue"
          v-if="reserve1 === item.start_nr || reserve2 === item.start_nr"
          style="position:absolute;top:2px;left:2px;color:white;font-size:10px;font-weight:bold"
        >
          <span v-text="reserve1 === item.start_nr ? 'R1' : 'R2'"></span>
        </v-avatar>

        <div style="position:absolute;right:50px;top:1px;font-size:10px">
          <span v-if="item.shoe_info.front">C</span>
          <span v-if="!item.shoe_info.front">Ȼ</span>
          <span v-if="item.shoe_info.back">C</span>
          <span v-if="!item.shoe_info.back">Ȼ</span>
        </div>

        <div v-if="item.system_horse.selected" class="horse-row-reduction-box">

          <!-- Horse reduction settings -->
          <!-- ABCD -->
          <v-menu :open-on-hover="false" v-if="system.reduction_rules.abcd_rule.use" offset-y transition="slide-y-transition">
            <template v-slot:activator="{ on }">
              <v-btn :disabled="isLocked" color="primary" v-on="on" v-text="item.system_horse.prio === 'M' ? '-' : item.system_horse.prio" text >
              </v-btn>
            </template>
            <v-list>
              <h3 style="padding:5px">ABCD Grupp</h3>
              <v-subheader>{{item.start_nr}}. {{item.name}}</v-subheader>

              <v-list-item v-for="(prio, index) in abcdList" :key="'prio-' + index" @click="setHorseValue(item, prio.value, 'prio')">
                <v-list-item-action>
                  <v-checkbox v-model="item.system_horse.prio" :value="prio.value"></v-checkbox>
                </v-list-item-action>
                <v-list-item-title>{{ prio.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <!-- POINTS -->
          <v-menu :open-on-hover="false" v-if="system.reduction_rules.points.use" offset-y transition="slide-y-transition">
            <template v-slot:activator="{ on }">
              <v-btn :disabled="isLocked" color="success" v-on="on" v-text="`${item.system_horse.points}p`" text dense>
              </v-btn>
            </template>
            <v-list>
              <h3 style="padding:5px">Poäng</h3>
              <v-subheader>{{item.start_nr}}. {{item.name}}</v-subheader>

              <v-list-item v-for="(points, index) in ['0', 1, 2, 3, 4, 5]" :key="'points-' + index" @click="setHorseValue(item, points, 'points')">
                <v-list-item-action>
                  <v-checkbox v-model="item.system_horse.points" :value="points"></v-checkbox>
                </v-list-item-action>
                <v-list-item-title>{{ points }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <!-- GROUPS -->
          <v-menu :open-on-hover="false" v-if="system.reduction_rules.groups.length" offset-y transition="slide-y-transition" :close-on-content-click=false>
            <template v-slot:activator="{ on }">
              <v-btn v-if="!isLocked" :disabled="isLocked" v-on="on" v-text="item.system_horse.group_code_list.toString() || 'Utg'" text style="color: #666">
              </v-btn>
              <v-btn v-if="isLocked" disabled v-on="on" v-text="item.system_horse.group_code_list.toString() || ''" text style="color: #666">
              </v-btn>
            </template>
            <v-list>
              <h3 style="padding:5px">Utgångar</h3>

              <v-list-item v-for="group in system.reduction_rules.groups" :key="`group-${group.group}`" @click="setHorseValue(item, group.group, 'group')">
                <v-list-item-action>
                  <v-checkbox v-model="item.system_horse.group_code_list" :value="group.group"></v-checkbox>
                </v-list-item-action>
                <v-list-item-title>{{ group.group }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <span v-if="!isLocked" style="text-align:right;padding-top:5px">{{horseCombos(item.leg_nr, item.start_nr)}}</span>
          <span v-if="isLocked && item.system_horse.selected" style="text-align:right;padding-top:5px">{{horseCombosLeft(item.start_nr)}}</span>

        </div>

      </v-list-item>
    </v-list>
    <v-menu v-for="(reserve, index) in [reserve1, reserve2]" :key="`reserve-${index}`" :open-on-hover="false" offset-y transition="slide-y-transition">
      <template v-slot:activator="{ on }">
        <v-btn text outlined :disabled="isLocked" color="info" v-on="on" dense >R{{index+1}}

          <v-avatar
            size="24px"
            class="green"
            style="color:white;font-size:14px;font-weight:bold;margin-left:3px"
            v-text="reserve > 0 ? reserve : '-'"
            outlined
          >
          </v-avatar>
        </v-btn>
      </template>
      <v-list>
        <h3 style="padding:5px">Reserv 1</h3>
        <v-list-item v-for="(horse, index2) in race.horse_list" :key="`'reserve-' + ${index2}`" @click="changeReserves">
          <v-list-item-action>
            <v-checkbox :disabled="reserve1 === horse.start_nr || reserve2 === horse.start_nr" v-model="$data['reserve' + (index + 1)]" :value="horse.start_nr"></v-checkbox>
          </v-list-item-action>
          <v-list-item-title>{{horse.start_nr}}. {{horse.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

  </v-card>
</v-col>
</template>
<style scoped>
.race-time-box {
  position:absolute;
  width:auto;
  height:20px;
  top:40px;
  left:15px;
  font-size:13px;
  color:#555
}
.horse-row {
  border-bottom: 1px solid lightgrey;
  margin: 0px;
  flex-flow: wrap;
}
.horse-row-content{
  padding-top: 3px;
  padding-bottom: 0px;
  padding-right: 5px;
  margin:0px;
  align-self:start;
}

.horse-row-reduction-box {
  position:relative;
  width:100%;
  justify-content: space-between;
  display:flex;
  vertical-align:middle;
  border: 1px dashed #ccc;
  background-color:#c5ffb5;
  padding-right: 5px;
}

.selected-avatar {
  background-color: green;
}
.selected-item {
  background-color: #e3fcdc;
  align-items: start;
  height: 80px;
  transition: height 0.5s, background-color 0.5s linear;
}
.not-selected-item {
  background-color: white;
  align-items: start;
  height: 40px;
  transition: height 0.5s, background-color 0.5s linear;
}
.not-selected-avatar {
  background-color: lightgrey;
}
.shoes-true {
  content: "C"
}
.shoes-false {
  content: "Ȼ"
}
.cancelled {
  background-color: #DDD;
}
.cancelled .v-list-item__title{
  text-decoration: line-through;
}
.race-title {
  font-weight:bolder;
}
.winner {
  border: 2px solid orange;
}
.race-results-box {
  border: none;
  background-color:white;
  border-radius: 9px;
}
</style>
<script>
import { mapActions } from 'vuex'
import $ from 'jquery'

export default {
  name: 'Race',
  props: ['race', 'system', 'sorting', 'showAllResults'],
  data () {
    return {
      dragging: -1,
      abcdList: [
        { name: 'Ingen', value: 'M' },
        { name: 'A', value: 'A' },
        { name: 'B', value: 'B' },
        { name: 'C', value: 'C' },
        { name: 'D', value: 'D' }
      ],
      reserve1: 0,
      reserve2: 0,
      showResults: false,
      topPanels: -1
    }
  },

  mounted () {
    // set up reserves
    this.reserve1 = this.system.reserves[this.race.leg_nr].r1
    this.reserve2 = this.system.reserves[this.race.leg_nr].r2
  },

  watch: {
    showAllResults: function () {
      this.showAllResults ? this.topPanels = 0 : this.topPanels = 1
    }
  },

  methods: {
    ...mapActions(['addHorseAction', 'removeHorseAction', 'setHorseValueAction', 'updateReservesAction']),

    changeReserves () {
      const reserves = { r1: this.reserve1, r2: this.reserve2, id: this.system.id, leg_nr: this.race.leg_nr }
      this.updateReservesAction(reserves)
    },

    setHorseValue (item, value, type) {
      let set
      if (type === 'group' && item.system_horse.group_code_list) {
        set = item.system_horse.group_code_list.includes(value)
      } else {
        set = false
      }
      const details = { id: this.system.id, leg_nr: item.leg_nr, start_nr: item.start_nr, type: type, value: value, selected: item.system_horse.selected, set: set }
      this.setHorseValueAction(details)
    },

    toggleHorse (horse) {
      const horseDetails = { id: this.system.id, leg_nr: horse.leg_nr, start_nr: horse.start_nr }
      if (horse.system_horse.selected === true) {
        this.removeHorseAction(horseDetails)
      } else {
        this.addHorseAction(horseDetails)
      }
    },

    dragStart (which, ev) {
      ev.dataTransfer.setData('Text', this.id)
      ev.dataTransfer.dropEffect = 'move'
      this.dragging = which
    },

    dragEnd (ev) {
      var el = document.elementsFromPoint(event.pageX - window.pageXOffset, event.pageY - window.pageYOffset)
      const target = $(el).filter('.horse-row')
      this.moveItem(this.dragging, this.findOwnRankById(target.attr('id')))
      this.dragging = -1
    },

    findOwnRankById (id) {
      const startNr = parseInt(id.split('-')[1])
      const ownRank = this.race.horse_list.find(x => x.start_nr === startNr).system_horse.own_rank
      return ownRank
    },

    moveItem (item, newPos) {
      const that = this
      item.system_horse.own_rank = newPos - 0.1
      const sortedItems = [...this.race.horse_list].sort(function (item1, item2) {
        if (item1.system_horse.own_rank < item2.system_horse.own_rank) {
          return -1
        } else {
          return +1
        }
      })
      sortedItems.forEach(function (item, index) {
        const oldRank = that.findOwnRankById(item.id)
        const newRank = index + 1
        // Only update rank for moved rows, to not make unnecessary calls to the backend
        if (oldRank !== newRank) {
          that.setHorseValue(item, newRank, 'own_rank')
        }
        item.system_horse.own_rank = (index + 1)
      })
    },

    horseCombos (legNr, startNr) {
      if (!this.system || !this.system.reduction_result) { return }
      const horseReductionResult = this.system.reduction_result.LegList.find(x => x.LegNr === legNr).HorseList.find(y => y.StartNr === startNr)
      return horseReductionResult.NumberOfRows + ' (' + Math.round(horseReductionResult.PercentageOfRows * 100) + '%)'
    },
    horseCombosLeft (startNr) {
      if (!this.results || !startNr || !this.results.HorseList) { return '-' }
      const horseListItem = this.results.HorseList.find(x => x.SN === startNr)
      if (!horseListItem) { return '---' }
      const combosLeft = horseListItem.NOR
      return `${combosLeft[0]} / ${combosLeft[1]} / ${combosLeft[2]}`
    }
  },

  computed: {
    results () {
      return (this.system.game_result && this.system.game_result.RaceList) ? this.system.game_result.RaceList.find(x => x.LegNr === this.race.leg_nr) : {}
    },

    raceNotStarted () {
      return new Date() < new Date(this.race.start_time)
    },

    raceStarted () {
      return !this.raceNotStarted && !this.raceOver
    },

    raceOver () {
      return this.results.Winners
    },

    displayResults () {
      return (this.showResults || this.showAllResults) && this.results.Winners
    },

    isLocked () {
      return this.system.locked
    },

    sortedItems () {
      const that = this
      return [...this.race.horse_list].sort(function (item1, item2) {
        let res = 0
        switch (that.sorting) {
          case 'start_nr':
            return item1[that.sorting] - item2[that.sorting]
          case 'stake_distribution_share':
            if (item1.cancelled) {
              return 1
            } else {
              return item2[that.sorting] - item1[that.sorting]
            }
          case 'odds':
            if (item1.cancelled) {
              return 1
            } else {
              return item1[that.sorting] - item2[that.sorting]
            }
          case 'own_rank':
            return (
              item1.system_horse.own_rank - item2.system_horse.own_rank
            )
          case 'selected':
            if (item1.system_horse.selected) {
              res--
            }
            if (item2.system_horse.selected) {
              res++
            }
            if (!item1.system_horse.selected || !item2.system_horse.selected) {
              return res
            }

            if (item1.system_horse.prio < item2.system_horse.prio) {
              res--
            }
            if (item1.system_horse.prio > item2.system_horse.prio) {
              res++
            }

            if (res !== 0) {
              return res
            }

            if (item1.system_horse.points < item2.system_horse.points) {
              res--
            }
            if (item1.system_horse.points > item2.system_horse.points) {
              res++
            }

            return res
          default:
            return item1.start_nr - item2.start_nr
        }
      })
    }
  }
}
</script>
